export enum PlayButtonStatus {
  LOAD = 'load',
  PAUSE = 'pause',
  PLAY = 'play'
}
